module.exports = __webpack_public_path__ + "img/252.b380e8e8.png";